<template>
  <div
    class="game-iframe"
    :class="{ 'full-screen': fullScreen }"
  >
    <ClientOnly>
      <div v-if="isShowModal" class="game-iframe__overlay">
        <div class="game-iframe__image-wrapper">
          <img
            :src="`${$config.cloudUrl}${gameImage}`"
            width="130"
            height="130"
            class="game-iframe__image"
            alt="game image"
          />
        </div>
        <UiText font="text-s" bold class="game-iframe__description">
          <UiText
            :text="$t('gamePage.provider')"
            font="body-text-small"
            color="typography-body01"
            class="game-iframe__logo-wrapper-mr"
          />
          <UiText
            :text="provider"
            font="body-text-small"
            color="typography-title02"
            class="game-iframe__text-uppercase"
          />
        </UiText>
        <UiText
          :text="gameName"
          font="body-text-big"
          bold
          color="typography-title02"
          class="mt16"
        />

        <BaseAuthOrRegister
          class="game-iframe__button mt16"
          color="primary"
          :text="$tc('gamePage.play')"
        />
        <UiBtn
          class="game-iframe__button mt8"
          transparent
          :text="$t('gamePage.demoGame')"
          @click="onStartDemoGame"
        />
      </div>
    </ClientOnly>
    <ClientOnly>
      <div v-if="isShowLoader" class="game-iframe__spinner" />
    </ClientOnly>

    <ClientOnly>
      <LazyHydrate when-idle>
        <iframe
          v-if="isShowGameIframe"
          v-show="!isShowLoader"
          id="game-iframe"
          ref="iframe"
          :key="get_game.data.url"
          :src="get_game.data.url"
          class="game-iframe__content"
          allowfullscreen
          allow="fullScreen"
          @load="onIframeLoad"
          @error="onIframeError"
        />
      </LazyHydrate>
    </ClientOnly>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import { mapActions, mapGetters } from 'vuex'
import BaseAuthOrRegister from '@/components/Base/AuthOrRegister'

const LOADER_MIN_TIME_MS = 1200
export default {
  name: 'TheGame',
  components: { BaseAuthOrRegister, LazyHydrate },
  props: {
    fullScreen: { type: Boolean },
  },
  data() {
    return {
      isDemoGameModalOpen: true,
      isStartDemoGame: false,
      isRestartingIframe: false,
      isIframeLoaded: false,
      isLoaderMinTimeOngoing: true,
    }
  },
  computed: {
    ...mapGetters('game', ['get_game']),
    ...mapGetters('user', {
      isLoggedIn: 'isLoggedIn',
      isUserVerified: 'isUserVerified',
    }),
    ...mapGetters('limits', ['get_limitsGamePause']),
    gameName() {
      return this.get_game.data.name
    },
    gameImage() {
      return this.get_game.data.iconUrlVertical
    },
    isShowLoader() {
      return this.isShowGameIframe && (!this.isIframeLoaded || this.isLoaderMinTimeOngoing)
    },
    isShowGameIframe() {
      return !this.isRestartingIframe && (this.isLoggedIn || this.isStartDemoGame)
    },
    isDemoGame() {
      return !this.isLoggedIn
    },
    isShowModal() {
      return this.isDemoGame && this.isDemoGameModalOpen && Object.keys(this.get_game.data).length
    },
    /** TODO: need add provider to game api */
    provider() {
      const data = this.get_game?.data

      if (data?.provider) {
        return data.provider
      }

      if (!data || !data.suggestions?.length) {
        return ''
      }

      return data.suggestions[0].provider || ''
    },
  },
  watch: {
    async get_limitsGamePause(val) {
      if (!val) return
      this.isRestartingIframe = true
      await this.fetch_game({ isLoggedIn: this.isLoggedIn, term: this.$route.params.term })
      this.isRestartingIframe = false
    },
  },
  mounted() {
    setTimeout(() => this.isLoaderMinTimeOngoing = false, LOADER_MIN_TIME_MS)
  },
  methods: {
    ...mapActions('game',['fetch_game']),
    onIframeLoad() {
      this.isIframeLoaded = true
    },
    onIframeError() {
      console.log('_________________onIframeError____________________')
    },
    onStartDemoGame() {
      this.isDemoGameModalOpen = false
      this.isStartDemoGame = true
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
